module.exports = __webpack_public_path__ + "static/media/LowTom808.5cfb29ce.wav";